import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//- material
import { withStyles } from '@material-ui/core/styles';
import { post } from '../../modules/utility';
import DeliveryTicket from './DeliveryTicket';

const styles = () => {
	//const fw = 1280;
	//const fh = 1664;

	return {
		root: {},
	};
};

class DriverDeliveryTickets extends Component {
	constructor(props) {
		super(props);
		const overrideUserId = _.get(this.props, ['match', 'params', 'userId']);
		const overrideShiftDate = _.get(this.props, ['match', 'params', 'overrideShiftDate']);
		const accessToken = _.get(this.props, ['match', 'params', 'accessToken']);

		if (!overrideUserId) {
			alert('Missing userId');
		}

		this.state = {
			overrideUserId,
			overrideShiftDate,
			accessToken,
			errors: [],
			isSearching: false,
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { overrideUserId, overrideShiftDate, accessToken } = this.state;

		this.setState({ isSearching: true });
		const params = {
			overrideUserId: parseInt(overrideUserId),
		};

		if (overrideShiftDate) {
			params.overrideShiftDate = overrideShiftDate;
		}

		if (accessToken) {
			params.accessToken = accessToken;
		}

		post({
			method: 'tmw.searchDeliveryTickets',
			params,
			callback: (err, r) => {
				if (err) {
					return this.setState({
						isSearching: false,
						searchError: err,
					});
				}

				this.setState({
					isSearching: false,
					deliveryTickets: r.deliveryTickets,
				});
			},
		});
	}

	render() {
		//const { classes } = this.props;
		const { deliveryTickets, isSearching, searchError } = this.state;

		if (searchError) {
			return (
				<div style={{ textAlign: 'center', fontSize: '22px', height: '100vh' }}>
					<div style={{ padding: 50, marginTop: 100 }}>
						<div>There was an error with your request.</div>
						<div>{searchError}</div>
						<br />
						<div>Please contact dispatch for your delivery tickets.</div>
					</div>
				</div>
			);
		}

		if (!deliveryTickets || isSearching) {
			return <div>Fetching delivery tickets...</div>;
		}
		return (
			<div>
				{deliveryTickets.map((deliveryTicket, i) => {
					return (
						<div key={`${i}_${deliveryTicket.stopNumber}`}>
							<DeliveryTicket deliveryTicket={deliveryTicket} />
							<div className="pageBreakTicket" />
							<div className="pageBreakTicketNotPrint" />
						</div>
					);
				})}
			</div>
		);
	}
}

DriverDeliveryTickets.propTypes = {
	classes: PropTypes.object.isRequired,
	//publicGetDriverReport : PropTypes.func,
	userMap: PropTypes.object,
	resourceMap: PropTypes.object,
};

export default _.flow([withStyles(styles)])(DriverDeliveryTickets);
